module.exports = __webpack_public_path__ + "static/img/calendar.8659b836.svg";